import React, { useState } from "react";
import DefaultButton from "../../styles/materialButtonStyle";
import { TextField } from "@material-ui/core";
import Notification from "../notification/Notification";
import MaterialDialog from "../../styles/materialDialog";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import { check2FA } from "../../../utils/check2FA";
import getUserInfo from "../../../utils/getUserInfo";
import { useTranslation } from "react-i18next";

import {
  StyledDialogAction,
  StyledDialogContent,
  StyledDialogHead,
  StyledDialogWrapper
} from "../../styles/styledDialog";
import { parseAxiosError } from "../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";

const UpdateBatchesStatus = ({ fetchBatches, batches }) => {
  const { t } = useTranslation("batchesPage");

  const [open, setOpen] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const defaultData = {
    status: "PROCESSED",
    twofa: null
  };

  const [updateData, setUpdateData] = useState(defaultData);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const updateBatchesStatus = async (event) => {
    event.preventDefault();

    setDisabled(true);

    let check2Fa = await check2FA(getUserInfo()["userId"], updateData.twofa);

    if (check2Fa.error) {
      setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
      setDisabled(false);

      return;
    }

    delete updateData.twofa;

    axios.put("/api/batches/" + batches.id, updateData, userAuthenticationConfig(false)).then(response => {
      if (response.status === 200) {
        fetchBatches();
        setNotification({ ...notification, visible: true, type: "success", message: t("table.success") });
        handleClose();
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    }).finally(() => setDisabled(false));
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setUpdateData(defaultData);
    setOpen(false);
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <React.Fragment>
        <DefaultButton
          className="stop-event"
          color="transparent"
          border="success"
          onClick={handleClickOpen}
        >
          {t("table.startImportant")}
        </DefaultButton>
        <MaterialDialog
          className="stop-event"
          open={open}
        >
          <StyledDialogWrapper>
            <StyledDialogHead>
              {t("table.startImportant")} {batches.name}
            </StyledDialogHead>
            <StyledDialogContent>
              <TextField
                id="twofa"
                label={t("table.twofa")}
                value={updateData.twofa}
                onChange={(data) => setUpdateData({ ...updateData, twofa: data.target.value })}

              />
            </StyledDialogContent>
            <StyledDialogAction col="2">
              <DefaultButton
                onClick={handleClose}
                color="danger"
                disabled={disabled}
              >
                {t("table.cancel")}
              </DefaultButton>
              <DefaultButton
                onClick={updateBatchesStatus}
                color="success"
                disabled={disabled}
              >
                {t("table.startImportant")}
              </DefaultButton>
            </StyledDialogAction>
          </StyledDialogWrapper>
        </MaterialDialog>
      </React.Fragment>
    </>
  );
};

export default UpdateBatchesStatus;